export const GET_WATER_UTILITY = 'VARUNA.GET_WATER_UTILITY'
